import api from '../../../services/api';

export const analyticsService = {
  getAnalytics: (months: string[]) => api.get('/transactions/analytics', { params: { months: months.join(',') } }),
};
